import { API } from 'src/common/config/API';
import {
  getCookie,
  setCookie,
  setGetUserName,
  getTokenDetails,
  decryptEncryptedJWT
} from 'src/common/config/FunctionHelper';
import {
  decryptCardToken,
  handleSnackBar
} from './config/FunctionHelperPartTwo';
import { setStripeLoader, setIsSiteSoftDeleted } from 'src/redux/siteAuditReducer';
import { store } from 'src/redux/store';
import { AxiosResponse } from 'axios';
import {
  IDraftACampaignProps,
  IDraftACampaignResponse
} from 'src/content/CitationBuilderV2/hooks/draftACampaign';
import { EmailReportResponse } from 'src/content/CitationBuilderV2/hooks/useEmailReport';
import { LocationApiResponse } from 'src/content/CitationBuilderV2/types';
import { ALL_DUMMY_RESPONSES } from 'src/content/orbitAi/keyword-assist/dummyResponse';
import { KeywordIntelligenceRunPayload } from 'src/content/orbitAi/types/keyword-assist.type';
import { BlogBlueprintsRunPayload, BlogRunPayload } from 'src/content/orbitAi/types/blog-generation-agent.types';
import { LocalSEOAgentReport, LocalSEOAgentRunPayload } from 'src/content/orbitAi/local-seo/types';
import { ReviewAutomationSettingsPayload, ReviewAutomationSettingsResponse, ReviewAutomationDashboardResponse } from 'src/content/orbitAi/types/review-automation.type';
import { UserAgentDetailsResponse, UpdateUserAgentsPayload, UpdateUserAgentsResponse } from 'src/content/orbitAi/types/user-agents.type';
import { AgentsStatusResponse } from 'src/content/orbitAi/types/agents-status.type';
import { BuyAddonPayload, BuyAddonResponse } from 'src/content/orbitAi/types/addon.type';
/**
 * Add sub pages
 *
 * @param {Object} payload Payload object containing request payload
 */
const addSubPages = (payload: object) => {
  return new Promise((resolve) => {
    API.addSubPages(
      API.EndPoint.addSubPages,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Update sub pages
 *
 * @param {Object} payload Payload object containing request payload
 * @param {String} subPageId Sub page is
 */
const updateSubPages = (payload: object, subPageId: string) => {
  return new Promise((resolve) => {
    API.updateSubpages(
      API.EndPoint.updateSubpages + '/' + subPageId,
      API.Method.patch,
      undefined,
      payload,
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Create scan page
 *
 * @param {Object} payload Payload object containing request payload
 */
const createScan = (payload: object) => {
  return new Promise((resolve) => {
    API.createScan(
      API.EndPoint.createScan,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Get boolean value based on suggestion from all response
 *
 * @param response for response
 */
const getResponseSuggestion = (response: any) => {
  return response['data']['response']['suggestions'].length ? false : true;
};

/**
 * Get suggestion data from all response
 *
 * @param response for response
 */
const getAllSuggestionDataResponse = (response: any) => {
  return response['data']['response'] ?? response['data']['response'];
};

/**
 * Get html from site
 *
 * @param {Object} payload Payload object containing request payload
 */
const getHtml = (payload: object) => {
  return new Promise((resolve) => {
    API.getHtmlFromUrl(
      API.EndPoint.getHtmlFromUrl,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Add site
 *
 * @param {Object} payload Payload object containing request payload
 */
const addSites = (payload: object) => {
  return new Promise((resolve) => {
    API.addSites(
      API.EndPoint.addSites,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Update user run scan
 *
 * @param {Object} payload Payload object containing request payload
 */
const updateUser = (payload: object) => {
  return new Promise((resolve) => {
    API.userUpdate(
      API.EndPoint.userUpdate,
      API.Method.patch,
      undefined,
      payload,
      async (response) => {
        if (response?.data?.token) {
          const encodedJWT = getCookie(process.env.REACT_APP_COOKIE_NAME);
          const jwtDecode: any = await decryptEncryptedJWT(encodedJWT);
          // const jwtDecode: any = jwt_decode(encodedJWT);
          if (jwtDecode) {
            setCookie(response?.data?.token, jwtDecode['name']);
          }
        }
        resolve(response);
      }
    );
  });
};

/**
 * Add sub pages
 *
 * @param {Object} payload Payload object containing request payload
 */
const addSubPagesWithPayload = async (
  time: number,
  title: string,
  sitesId: string,
  url: string,
  getAllSuggestion: any
) => {
  const payload = {
    time: time,
    title: title,
    sites_id: sitesId,
    created_at: time,
    url: url,
    total_checks: getAllSuggestion.length,
    optimized_checks: getAllSuggestion.filter(function (x) {
      return x !== false;
    }).length
  };
  // Call add sub page api for add sub page into database
  let addSubPagesResponse = await addSubPages(payload);
};

/**
 * Update scan count
 *
 */
const updateScanCount = () => {
  return new Promise((resolve) => {
    API.updateScan(
      API.EndPoint.updateScan,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * User detail api
 *
 */
const userDetailsData = (userEmail) => {
  return new Promise((resolve) => {
    API.v2getUserDetails(
      API.EndPoint.v2UserDetails,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Run scan API
 *
 * @param {Object} payload Payload object containing request payload
 */
const runScanChecks = (payload: object) => {
  return new Promise((resolve) => {
    API.optimizeScanChecks(
      API.EndPoint.optimizeScanChecks,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Checks scan
 *
 * @param {Object} payload Payload object containing userid
 */
const runCheckScan = (payload: object) => {
  return new Promise((resolve) => {
    API.checkScan(
      API.EndPoint.checkScan,
      API.Method.get,
      undefined,
      payload,
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * new V2 get User api
 *
 * @param {Object} payload Payload object containing empty
 */
const v2UserDetails = () => {
  return new Promise((resolve) => {
    API.v2getUserDetails(
      API.EndPoint.v2UserDetails,
      API.Method.get,
      undefined,
      {},
      (response) => {
        // Rename the key from 'adminSubscription' to 'subscription'
        let result = response?.data?.response;
        if (response?.status === 200) {
          result.subscription = result?.adminSubscription
            ? result?.adminSubscription
            : result?.subscription;
          resolve(result);
        } else if (response?.status === 429) {
          handleSnackBar();
        } else {
          resolve(result);
        }
      }
    );
  });
};

/**
 * new V2 get Sites details
 *
 * @param {Object} payload Payload object containing empty
 */
const v2SitesDetails = () => {
  return new Promise((resolve) => {
    API.v2getSiteDetails(
      API.EndPoint.v2SiteDetails,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response?.data?.response);
      }
    );
  });
};

/**
 * Get addon details
 *
 * @param {Object} payload Payload object containing empty
 */
const getAddonDetails = () => {
  return new Promise((resolve) => {
    API.getAllUserAddons(
      API.EndPoint.getAllUserAddons,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data?.slots);
      }
    );
  });
};

/**
 * Get subscription details stripe
 *
 * @param {Object} payload Payload object containing empty
 */
const getSubscriptionDetailsStripe = () => {
  return new Promise(async (resolve, reject) => {
    let tokenStr: any = getCookie(process.env.REACT_APP_COOKIE_NAME);
    let decoded: any = await getTokenDetails(tokenStr);
    if (decoded.user_details) {
    }
    API.subscriptionDetailsStripe(
      API.EndPoint.subscriptionDetailsStripe,
      API.Method.post,
      undefined,
      {
        email: decoded.user_details
          ? decoded.user_details.email
          : setGetUserName()
      },
      (response) => {
        try {
          if (response?.status === 200) {
            let subscription = response?.data?.subscription;
            if (subscription?.card) {
              try {
                subscription.card = decryptCardToken(
                  subscription?.card,
                  subscription?.subscription_id
                );
              } catch (error) {
                console.error('Error decrypting card token', error);
                reject('Error decrypting card token');
              }
            }
            resolve(subscription);
          }
          if (response?.status === 429) {
            handleSnackBar();
          }
          store.dispatch(setStripeLoader(false));
        } catch (error) {
          reject('Error processing subscription details');
        }
      }
    );
  });
};

/**
 * Get (Analytics) site
 *
 * @param {Object} payload Payload object containing empty
 */
const getDomainGoogle = (url, month) => {
  return new Promise((resolve) => {
    API.getDomain(
      API.EndPoint.getDomain,
      API.Method.post,
      undefined,
      { url, month },
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Get (Analytics) site
 *
 * @param {Object} payload Payload object containing empty
 */
const removeSite = (siteId) => {
  return new Promise((resolve) => {
    API.getDomain(
      `${API.EndPoint.removeSite}/${siteId}`,
      API.Method.delete,
      undefined,
      {},
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Get (deleteScan) site
 *
 * @param {Object} payload Payload object containing empty
 */
const deleteScan = (deleteScanId) => {
  return new Promise((resolve) => {
    API.deleteScan(
      `${API.EndPoint.deleteScan}/${deleteScanId}`,
      API.Method.delete,
      undefined,
      {},
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Get (Analytics) site
 *
 * @param {Object} payload Payload object containing empty
 */
const getPreviousScan = (payload) => {
  return new Promise((resolve) => {
    API.getPreviousScan(
      API.EndPoint.getPreviousScan,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        try {
          resolve(response?.data);
        } catch (error) {
          if (error?.response?.status == 429) {
            handleSnackBar();
          }
        }
      }
    );
  });
};

/**
 * Get (Insite) site
 *
 * @param {Object} payload Payload url
 */
const getInsight = (payload, cancelToken) => {
  return new Promise((resolve) => {
    API.getInsight(
      API.EndPoint.getInsight,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        try {
          resolve(response?.data);
        } catch (error) {
          if (error?.response?.status == 429) {
            handleSnackBar();
          }
        }
      },
      cancelToken
    );
  });
};

/**
 * Get (Insite) site
 *
 * @param {Object} payload Payload url as a data-type string
 * @returns {Object} response.
 */
const getRecommended = (payload) => {
  return new Promise((resolve) => {
    API.getRecommended(
      API.EndPoint.getRecommended,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      },
      {}
    );
  });
};

/**
 * Get (Insight Graph) .
 *
 * @param {Object} payload  url as a data-type string
 *
 * @returns {Object} response.
 */
const getInsightGraph = (payload) => {
  return new Promise((resolve) => {
    API.getInsightGraph(
      API.EndPoint.getInsightGraph,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Get hire us call
 *
 */
const getHireUs = () => {
  return new Promise((resolve) => {
    API.getHireUs(
      API.EndPoint.hireUs,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response);
      }
    );
  });
};

/**
 * Retrieve a list of invoices using the paymentGetInvoices API.
 *
 * @async
 * @function
 * @returns {Promise<object|null>} A promise that resolves to the invoice data or null if there was an error.
 * @throws {Error} Throws an error if the API request fails.
 */
const paymentGetInvoices = () => {
  return new Promise((resolve) => {
    API.paymentGetInvoices(
      API.EndPoint.paymentGetInvoices,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Get site SubPages URL details
 *
 * @param {Object} payload  url as a data-type string
 */
const getSiteAuditUrl = (payload: object) => {
  return new Promise((resolve) => {
    API.siteAuditUrl(
      API.EndPoint.siteAuditUrl,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Run Audit scan
 *
 * @param {Object} payload  url as a data-type string
 */
const runAuditUrls = (payload: object) => {
  return new Promise((resolve) => {
    API.auditOptimize(
      API.EndPoint.auditOptimize,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Get Audit sites details
 *
 * @returns
 */
const getAuditSiteDetail = (
  siteid,
  page,
  pagesize,
  sitePageUrl,
  field,
  isDesc
) => {
  let requestParam = `?siteId=${siteid}&page=${page}&pageSize=${pagesize}&sitePageUrl=${sitePageUrl}&sortOrderField=${field}&desc=${isDesc}`;
  return new Promise((resolve) => {
    API.getAuditSiteDetail(
      API.EndPoint.getAuditSiteDetail + requestParam,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data?.response);
      }
    );
  });
};

/**
 * Get Audit sites list
 *
 * @returns
 */
const auditSite = () => {
  return new Promise((resolve) => {
    API.AuditSite(
      API.EndPoint.AuditSite,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data?.response);
      }
    );
  });
};

/**
 * Get the audit status of a site by sending a POST request to the AuditStatus API.
 *
 * @async
 * @function
 * @param {string} siteId - The ID of the site for which you want to retrieve the audit status.
 * @returns {Promise<any|null>} A promise that resolves to the audit status data or null if there was an error.
 * @throws {Error} Throws an error if the API request fails.
 */
const auditStatus = (site_Id) => {
  return new Promise((resolve) => {
    API.AuditStatus(
      API.EndPoint.AuditStatus,
      API.Method.post,
      undefined,
      { siteId: site_Id },
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Retrieve individual scan data with pagination.
 *
 * @async
 * @function
 * @param {number} page - The page number to retrieve.
 * @param {number} pagesize - The number of items per page.
 * @returns {Promise<any|null>} A promise that resolves to the individual scan data or null if there was an error.
 * @throws {Error} Throws an error if the API request fails.
 */
const indiVidualScan = (page, pagesize, sitePageUrl, field, isDesc) => {
  return new Promise((resolve) => {
    API.getIndividualScan(
      API.EndPoint.getIndividualScan +
        `?page=${page}&pageSize=${pagesize}&sitePageUrl=${sitePageUrl}&sortOrderField=${field}&desc=${isDesc}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data?.response);
      }
    );
  });
};

/**
 * Add or update monitoring data for a site.
 *
 * @async
 * @function
 * @param {string} siteid - The ID of the site to add or update monitoring data for.
 * @param {string} monitoring - The monitoring data to add or update.
 * @param {string} monoitoringTime - The time of monitoring data.
 * @returns {Promise<any|null>} A promise that resolves to the response data or null if there was an error.
 * @throws {Error} Throws an error if the API request fails.
 */
const addUpdateMonitoring = (payload) => {
  return new Promise((resolve) => {
    API.addUpdateMonitoring(
      API.EndPoint.addUpdateMonitoring,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Get the count of audit checkers for a site.
 *
 * @async
 * @function
 * @param {string} siteid - The ID of the site to retrieve audit checker count for.
 * @returns {Promise<any|null>} A promise that resolves to the count data or null if there was an error.
 * @throws {Error} Throws an error if the API request fails.
 */
const auditCheckersCount = (siteid, compare = '') => {
  return new Promise((resolve) => {
    API.auditCheckersCount(
      API.EndPoint.auditCheckersCount,
      API.Method.post,
      undefined,
      { siteId: siteid, compare },
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Delete subpages associated with a site.
 *
 * @async
 * @function
 * @param {string} siteId - The ID of the site whose subpages need to be deleted.
 * @returns {Promise<any>} A promise that resolves when the subpages are deleted.
 * @throws {Error} Throws an error if the API request fails.
 */
const deleteSubPages = (siteId) => {
  return new Promise((resolve) => {
    API.deleteSubPages(
      API.EndPoint.deleteSubPages + `${siteId}`,
      API.Method.delete,
      undefined,
      {},
      (response: any) => {
        resolve(response.data);
      }
    );
  });
};

/**
 * Get detailed information about a site.
 *
 * @async
 * @function
 * @param {string} siteId - The ID of the site for which you want detailed information.
 * @returns {Promise<any|null>} A promise that resolves to the site details or null if there was an error.
 * @throws {Error} Throws an error if the API request fails.
 */
const siteDetail = (siteId, compare, disableDisconnectPopup = false) => {
  return new Promise((resolve) => {
    const payload = {
      siteId: siteId,
      compare,
      disableDisconnectPopup
    };

    API.siteDetail(
      API.EndPoint.siteDetail,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        const isDelete = response?.data?.response?.isDelete === true;
        store.dispatch(setIsSiteSoftDeleted(isDelete));
        if (response?.data?.response) {
          response.data.response.isDelete = isDelete;
        }
        resolve(response.data);
      }
    );
  });
};

/**
 * Get the count of keywords for a URL.
 *
 * @async
 * @function
 * @param {string} url - The URL for which you want to retrieve keyword count.
 * @returns {Promise<any|null>} A promise that resolves to the keyword count or null if there was an error.
 * @throws {Error} Throws an error if the API request fails.
 */
const getKeywordsCount = (url, compare) => {
  return new Promise((resolve) => {
    API.getKeywordsCount(
      API.EndPoint.getKeywordsCount,
      API.Method.post,
      undefined,
      { url: url, compare },
      (response: any) => {
        resolve(response.data);
      }
    );
  });
};

/**
 * Get monthly traffic data for a URL.
 *
 * @async
 * @function
 * @param {string} url - The URL for which you want to retrieve monthly traffic data.
 * @returns {Promise<any|null>} A promise that resolves to the monthly traffic data or null if there was an error.
 * @throws {Error} Throws an error if the API request fails.
 */
const getMonthlyTraffic = (url, compare) => {
  return new Promise((resolve) => {
    API.getMonthlyTraffic(
      API.EndPoint.getMonthlyTraffic,
      API.Method.post,
      undefined,
      { url: url, compare },
      (response: any) => {
        resolve(response.data);
      }
    );
  });
};

/**
 * Generate a PDF report with site details.
 *
 * @async
 * @function
 * @param {string} siteId - The ID of the site for which you want to generate a PDF report.
 * @returns {Promise<any|null>} A promise that resolves to the PDF report data or null if there was an error.
 * @throws {Error} Throws an error if the API request fails.
 */
const generateSiteDetailPdf = (siteId, compare = '') => {
  return new Promise((resolve) => {
    API.generateSiteDetailPdf(
      API.EndPoint.generateSiteDetailPdf,
      API.Method.post,
      undefined,
      { siteId: siteId, compare },
      (response: any) => {
        resolve(response.data);
      }
    );
  });
};

/**
 * Stop the audit for a specific site.
 *
 * @param {number} siteId - The ID of the site for which the audit should be stopped.
 * @returns {Promise} A promise that resolves with the response data.
 */
const stopAudit = (siteId) => {
  return new Promise((resolve) => {
    API.stopAudit(
      API.EndPoint.stopAudit,
      API.Method.post,
      undefined,
      { siteId: siteId },
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Re-audit a specific site.
 *
 * @param {number} siteId - The ID of the site that should be re-audited.
 * @returns {Promise} A promise that resolves with the response data.
 */

const reAudit = (
  siteId,
  checkedUrls,
  unCheckedUrls,
  resolution = null,
  selected_image_size = null,
  uniqueId = null,
  isAiVisibility = null,
  isAiFieldsUpdated = false
) => {
  return new Promise((resolve) => {
    API.reAudit(
      API.EndPoint.reAudit,
      API.Method.post,
      undefined,
      {
        siteId: siteId,
        checkedUrls,
        unCheckedUrls,
        resolution,
        selected_image_size,
        uniqueId,
        isAiVisibility,
        isAiFieldsUpdated
      },
      (response) => {
        try {
          resolve(response?.data);
        } catch (error) {
          if (error?.response?.status == 429) {
            handleSnackBar();
          }
        }
      }
    );
  });
};

/**
 * Retrieve scans by issue title for a specific site.
 *
 * @param {string} title - The title of the issue.
 * @param {number} siteId - The ID of the site.
 * @returns {Promise} A promise that resolves with the response data.
 */
const getScansByIssue = (title, siteId) => {
  return new Promise((resolve) => {
    API.getScansByIssue(
      API.EndPoint.getScansByIssue,
      API.Method.post,
      undefined,
      { title: title, siteId: siteId },
      (response) => {
        try {
          resolve(response);
        } catch (error) {
          if (error?.response?.status == 429) {
            handleSnackBar();
          }
        }
      }
    );
  });
};

/**
 * Creates a new member with the provided name, email, and password.
 * @param {string} name - The name of the member
 * @param {string} email - The email of the member
 * @param {string} password - The password for the member
 * @returns {Promise} - A promise that resolves with the response data
 */
const createMember = (name, email, password) => {
  return new Promise((resolve) => {
    // Make a call to the API to create a new member
    API.createMember(
      API.EndPoint.createMember,
      API.Method.post,
      undefined,
      { name, email, password },
      (response) => {
        try {
          resolve(response?.data);
        } catch (error) {
          if (error?.response?.status == 429) {
            handleSnackBar();
          }
        }
      }
    );
  });
};

/**
 * Updates the subscription slots for a member.
 * @param {string} email - The email of the member
 * @param {string} planId - The ID of the subscription plan
 * @param {number} slots - The number of slots to update to
 * @returns {Promise} - A promise that resolves with the response data
 */
const slotSubscriptionUpdate = (email, planId, slots) => {
  return new Promise((resolve) => {
    // Make a call to the API to update the subscription slots
    API.slotSubscriptionUpdate(
      API.EndPoint.slotSubscriptionUpdate,
      API.Method.post,
      undefined,
      { email, planId, slots },
      (response) => {
        try {
          resolve(response?.data);
        } catch (error) {
          if (error?.response?.status == 429) {
            handleSnackBar();
          }
        }
      }
    );
  });
};

/**
* Retrieves the full list of slots.
 * Backend pagination/status filtering has been removed; FE manages it locally.
 */
const slotList = () => {
  return new Promise((resolve) => {
    // Make a call to the API to retrieve the slot list
    API.slotList(
      API.EndPoint.slotList,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response?.data?.response);
      }
    );
  });
};

/**
 * Invites a user to a slot based on the provided invitation email and slot ID.
 * @param {string} invitationEmail - The email of the invited user
 * @param {string} slotId - The ID of the slot
 * @returns {Promise} - A promise that resolves with the response data
 */
const inviteUser = (invitationEmail, slotId) => {
  return new Promise((resolve) => {
    // Make a call to the API to invite a user to a slot
    API.inviteUser(
      API.EndPoint.inviteUser,
      API.Method.post,
      undefined,
      { invitationEmail, slotId },
      (response) => {
        resolve(response);
      }
    );
  });
};

/**
 * Cancels an invitation for a slot based on the provided slot ID.
 * @param {string} slotId - The ID of the slot
 * @returns {Promise} - A promise that resolves with the response data
 */
const cancelInvitation = (slotId) => {
  return new Promise((resolve) => {
    // Make a call to the API to cancel an invitation for a slot
    API.cancelInvitation(
      API.EndPoint.cancelInvitation + `${slotId}`,
      API.Method.delete,
      undefined,
      {},
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Resends an invitation for a slot based on the provided invitation email and slot ID.
 * @param {string} invitationEmail - The email of the invited user
 * @param {string} slotId - The ID of the slot
 * @returns {Promise} - A promise that resolves with the response data
 */
const resendInvitation = (invitationEmail, slotId) => {
  return new Promise((resolve) => {
    // Make a call to the API to resend an invitation for a slot
    API.resendInvitation(
      API.EndPoint.resendInvitation,
      API.Method.post,
      undefined,
      { invitationEmail, slotId },
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Deletes a slot based on the provided slot ID and site IDs.
 * @param {string} slotId - The ID of the slot to delete
 * @param {string[]} siteIds - The IDs of the sites associated with the slot
 * @returns {Promise} - A promise that resolves with the response
 **/
const deleteSlot = (slotId) => {
  return new Promise((resolve) => {
    API.deleteSlot(
      API.EndPoint.deleteSlot,
      API.Method.post,
      undefined,
      { slotId },
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Deletes a member with the specified ID.
 * @param {string} memberId - The ID of the member to be deleted.
 * @returns {Promise<any>} A promise that resolves with the response data.
 */
const deleteMember = (memberId) => {
  return new Promise((resolve) => {
    API.deleteMember(
      API.EndPoint.deleteMember + `${memberId}`,
      API.Method.delete,
      undefined,
      {},
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Removes multiple sites by their IDs.
 * @param {string[]} siteIds - An array of site IDs to be removed.
 * @returns {Promise<any>} A promise that resolves with the response data.
 */
const removeMultiSites = (siteIds) => {
  return new Promise((resolve) => {
    API.removeMultiSites(
      API.EndPoint.removeMultiSites,
      API.Method.post,
      undefined,
      { siteIds },
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * Retrieves the skipped URLs for a specific site.
 * @param {string} siteId - The ID of the site for which to retrieve skipped URLs.
 * @returns {Promise<any>} A promise that resolves with the response data.
 */
const getSkippedUrls = (siteId) => {
  return new Promise((resolve) => {
    API.getSkippedUrls(
      API.EndPoint.getSkippedUrls,
      API.Method.post,
      undefined,
      { siteId },
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getReAuditCount = (siteId) => {
  return new Promise((resolve) => {
    API.getReAuditCount(
      API.EndPoint.getReAuditCount,
      API.Method.post,
      undefined,
      { siteId },
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getRecommendationKeys = (url) => {
  return new Promise((resolve) => {
    API.getRecommendationKeys(
      API.EndPoint.getRecommendationKeys,
      API.Method.post,
      undefined,
      { url },
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const generateBlogPost = (payload) => {
  return new Promise((resolve) => {
    API.generateBlogPost(
      API.EndPoint.generateBlogPost,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const createLeadForm = (payload) => {
  return new Promise((resolve) => {
    API.createLeadForm(
      API.EndPoint.createLeadForm,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getLeadForm = (leadId) => {
  return new Promise((resolve) => {
    // Make a call to the API to retrieve the slot list
    API.getLeadForm(
      API.EndPoint.getLeadForm + `${leadId}`,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response?.data?.response);
      }
    );
  });
};

const createLead = (payload) => {
  return new Promise((resolve) => {
    API.createLead(
      API.EndPoint.createLead,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getLeadDetails = () => {
  return new Promise((resolve) => {
    // Make a call to the API to retrieve the slot list
    API.getLeadDetails(
      API.EndPoint.getLeadDetails,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response?.data?.response);
      }
    );
  });
};

const getUserLeadForm = () => {
  return new Promise((resolve) => {
    // Make a call to the API to retrieve the slot list
    API.getUserLeadForm(
      API.EndPoint.getUserLeadForm,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response?.data?.response);
      }
    );
  });
};

const deleteLead = (leadId) => {
  return new Promise((resolve) => {
    API.deleteLead(
      API.EndPoint.deleteLead + `${leadId}`,
      API.Method.delete,
      undefined,
      {},
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const indexedCheckUpdate = (siteId: string) => {
  return new Promise((resolve) => {
    API.indexedCheckUpdate(
      API.EndPoint.indexedCheckUpdate,
      API.Method.post,
      undefined,
      { siteId },
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getKeywordOverview = (
  keywords: any,
  locationCode: string,
  url: string,
  isKeywordOverview: any
) => {
  return new Promise((resolve) => {
    API.getKeywordOverview(
      API.EndPoint.getKeywordOverview,
      API.Method.post,
      undefined,
      { keywords, locationCode, url, isKeywordOverview },
      (response) => {
        // Check if keywordDifficulty[0] exists, otherwise resolve with response.data

        resolve(response?.data);
      }
    );
  });
};

const getRelatedKeywords = (payload: any) => {
  return new Promise((resolve) => {
    API.getRelatedKeywords(
      API.EndPoint.getRelatedKeywords,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getCompetitorDetails = (
  competitor: any,
  locationCode: string,
  competitorAnalysisId: any = null
) => {
  return new Promise((resolve) => {
    API.getCompetitorDetails(
      API.EndPoint.getCompetitorDetails,
      API.Method.post,
      undefined,
      { competitor, locationCode, competitorAnalysisId },
      (response) => {
        // Check if keywordDifficulty[0] exists, otherwise resolve with response.data
        resolve(response?.data);
      }
    );
  });
};

const topOrganicKeywords = (payload: any) => {
  return new Promise((resolve) => {
    API.topOrganicKeywords(
      API.EndPoint.topOrganicKeywords,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        // Check if keywordDifficulty[0] exists, otherwise resolve with response.data
        resolve(response?.data);
      }
    );
  });
};

const getCreditDetails = () => {
  return new Promise((resolve) => {
    // Make a call to the API to retrieve the slot list
    API.getCreditDetails(
      API.EndPoint.getCreditDetails,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response?.data?.response);
      }
    );
  });
};

/**
 * Get Seo Academy call
 *
 */
const getSeoAcademy = () => {
  return new Promise((resolve) => {
    API.getSeoAcademy(
      API.EndPoint.getSeoAcademy,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response);
      }
    );
  });
};

const getLogout = () => {
  return new Promise((resolve) => {
    API.logout(
      API.EndPoint.logout,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response);
      }
    );
  });
};

const userRegistration = (payload: any) => {
  return new Promise((resolve) => {
    API.userRegistration(
      API.EndPoint.registration,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        try {
          resolve(response?.data);
        } catch (error) {
          if (error?.response?.status == 429) {
            handleSnackBar();
          }
        }
      }
    );
  });
};

const refreshToken = ({ refreshToken }) => {
  return new Promise((resolve) => {
    API.refreshToken(
      API.EndPoint.refreshToken,
      API.Method.post,
      undefined,
      { refreshToken },
      (response: any) => {
        resolve(response);
      }
    );
  });
};

const marketPlaceUsersCount = (payload: any) => {
  return new Promise((resolve) => {
    API.marketPlaceUsersCount(
      API.EndPoint.marketPlaceUsersCount,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response);
      }
    );
  });
};

const getGscGraphDetails = (payload: any) => {
  return new Promise((resolve) => {
    API.getGscGraphDetails(
      API.EndPoint.getGscGraphDetails,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getOrganicSearchTraffic = (payload: any) => {
  return new Promise((resolve) => {
    API.getOrganicSearchTraffic(
      API.EndPoint.getOrganicSearchTraffic,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const createBriefPost = (payload: any) => {
  return new Promise((resolve) => {
    API.createBriefPost(
      API.EndPoint.createBriefPost,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getBlogDetail = (siteId: any) => {
  return new Promise((resolve) => {
    API.getBlogDetail(
      API.EndPoint.getBlogDetail,
      API.Method.post,
      undefined,
      { siteId },
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getCardDetail = () => {
  return new Promise((resolve, reject) => {
    API.getCardDetail(
      API.EndPoint.getCardDetail,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        try {
          if (response?.status === 200) {
            let subscription: any = response?.data?.data;
            if (subscription?.card) {
              try {
                subscription.card = decryptCardToken(
                  subscription?.card,
                  subscription?.subscription_id
                );
              } catch (error) {
                console.error('Error decrypting card token', error);
                reject('Error decrypting card token');
              }
            }
            resolve(subscription);
          }
          if (response?.status === 429) {
            handleSnackBar();
          }
          store.dispatch(setStripeLoader(false));
        } catch (error) {
          reject('Error processing subscription details');
        }
        resolve(response);
      }
    );
  });
};

const buyAddon = async (payload) => {
  return new Promise((resolve) => {
    API.buyAddon(
      API.EndPoint.buyAddon,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getAllPlan = () => {
  return new Promise((resolve) => {
    API.allPlan(
      API.EndPoint.allPlan,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response);
      }
    );
  });
};

const upgradeDowngradePlan = async (payload) => {
  return new Promise((resolve) => {
    API.upgradeDowngradePlan(
      API.EndPoint.upgradeDowngradePlan,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getPlanDetails = (planName: string = 'Agency') => {
  return new Promise((resolve) => {
    API.getPlanDetails(
      API.EndPoint.getPlanDetails + `?planName=${planName}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const downgradeDeactivateOffers = async (payload) => {
  return new Promise((resolve) => {
    API.downgradeDeactivateOffers(
      API.EndPoint.downgradeDeactivateOffers,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const resumePausedSubscription = async (payload) => {
  return new Promise((resolve) => {
    API.resumePausedSubscription(
      API.EndPoint.resumePausedSubscription,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const topRankingKeywordSuggestions = async (payload) => {
  return new Promise((resolve) => {
    API.topRankingKeywordSuggestions(
      API.EndPoint.topRankingKeywordSuggestions,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const keywordTracking = async (payload) => {
  return new Promise((resolve) => {
    API.keywordTracking(
      API.EndPoint.keywordTracking,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getKeywordTracking = (
  siteId,
  currentDate = null,
  compareDate = null,
  isPdf = null
) => {
  return new Promise((resolve) => {
    let queryParams = '';
    if (currentDate && compareDate) {
      queryParams = `?currentDate=${currentDate}&compareDate=${compareDate}`;
    }
    if (isPdf) {
      queryParams = `?ifPDFData=true`;
    }
    // Make a call to the API to retrieve the slot list
    API.getKeywordTracking(
      API.EndPoint.getKeywordTracking + `/${siteId}` + queryParams,
      API.Method.get,
      undefined,
      {},
      (response) => {
        resolve(response?.data);
      }
    );
  });
};
const getCompetitorAnalysis = (id) => {
  return new Promise((resolve) => {
    API.competitorAnalysis(
      API.EndPoint.competitorAnalysis + (id ? `?siteId=${id}` : ''),
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const deleteKeywordTracking = (payload) => {
  return new Promise((resolve) => {
    API.deleteKeywordTracking(
      API.EndPoint.deleteKeywordTracking,
      API.Method.delete,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};
const getKeywordResearchTable = (id) => {
  return new Promise((resolve) => {
    API.keywordResearchTable(
      API.EndPoint.keywordResearchTable + id,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const updateMonitoringFrequency = async (payload) => {
  return new Promise((resolve) => {
    API.updateMonitoringFrequency(
      API.EndPoint.updateMonitoringFrequency,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};
const getCompetitorAnalysisTable = (id) => {
  return new Promise((resolve) => {
    API.competitorAnalysisTable(
      API.EndPoint.competitorAnalysisTable + id,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getKeywordResearch = (id) => {
  return new Promise((resolve) => {
    API.keywordResearch(
      API.EndPoint.keywordResearch + (id ? `?siteId=${id}` : ''),
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getPreviousBlogPost = (id) => {
  return new Promise((resolve) => {
    API.getPreviousBlogPost(
      API.EndPoint.getPreviousBlogPost + id,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getPreviousBlogPostIdeas = (id) => {
  return new Promise((resolve) => {
    API.getPreviousBlogPostIdeas(
      API.EndPoint.getPreviousBlogPostIdeas + id,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const disconnectGSC = async (payload): Promise<AxiosResponse<any, any>> => {
  return new Promise((resolve) => {
    API.disconnectGSC(
      API.EndPoint.disconnectGSC,
      API.Method.delete,
      {},
      payload,
      async (response: any) => {
        resolve(response);
      }
    );
  });
};

const getKeywordPosition = async (payload) => {
  return new Promise((resolve) => {
    API.getKeywordPosition(
      API.EndPoint.getKeywordPosition,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getCreateUpdateKeywordList = async (payload) => {
  return new Promise((resolve) => {
    API.createUpdateKeywordList(
      API.EndPoint.createUpdateKeywordList,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getKeywordList = (keywordFolderId = null) => {
  return new Promise((resolve) => {
    API.getKeywordList(
      API.EndPoint.getKeywordList +
        (keywordFolderId ? `?keywordFolderId=${keywordFolderId}` : ''),
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getKeywordListDetails = (id) => {
  return new Promise((resolve) => {
    API.getKeywordListDetails(
      API.EndPoint.getKeywordListDetails + `/${id}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const deleteKeywordList = (id) => {
  return new Promise((resolve) => {
    API.deleteKeywordList(
      API.EndPoint.deleteKeywordList + `/${id}`,
      API.Method.delete,
      undefined,
      {},
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const deleteKeywordListDetails = (payload) => {
  return new Promise((resolve) => {
    API.deleteKeywordListDetails(
      API.EndPoint.deleteKeywordListDetails,
      API.Method.delete,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const handleDeleteScans = (payload: { ids: string[] }) => {
  return new Promise((resolve) => {
    try {
      API.deleteMultipleItems(
        API.EndPoint.deleteMultipleItems,
        API.Method.delete,
        {},
        payload,
        async (response: any) => {
          resolve(response);
        }
      );
    } catch (error) {}
  });
};

const getBackLinksDetails = async (payload) => {
  return new Promise((resolve) => {
    API.getBackLinksDetails(
      API.EndPoint.getBackLinksDetails,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const addLocalSEOTag = () => {
  return new Promise((resolve) => {
    API.getKeywordListDetails(
      API.EndPoint.localSEOTag,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const celebrationFlag = (siteId) => {
  return new Promise((resolve) => {
    API.celebrationFlag(
      API.EndPoint.celebrationFlag + `/${siteId}`,
      API.Method.patch,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getAddon = (isQuery = false, type = '') => {
  return new Promise((resolve) => {
    API.getAddon(
      API.EndPoint.getAddon + (isQuery ? `?type=${type}` : ''),
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const googleBusiness = () => {
  return new Promise((resolve) => {
    API.googleBusiness(
      API.EndPoint.googleBusiness,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const googleBusinessToken = (payload) => {
  return new Promise((resolve) => {
    API.googleBusinessToken(
      API.EndPoint.googleBusinessToken,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getLocations = (payload) => {
  return new Promise((resolve) => {
    API.getLocations(
      API.EndPoint.getLocations,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const locationInfo = (
  locationId,
  selectedAccountId,
  squareSpaceSiteId = null
) => {
  return new Promise((resolve) => {
    const url =
      API.EndPoint.locationInfo +
      `/${locationId}?accountId=${selectedAccountId}` +
      (squareSpaceSiteId ? `&squareSpaceSiteId=${squareSpaceSiteId}` : '');
    API.locationInfo(url, API.Method.get, undefined, {}, (response: any) => {
      resolve(response?.data);
    });
  });
};

const buyKeywordAddon = async (payload) => {
  return new Promise((resolve) => {
    API.buyKeywordAddon(
      API.EndPoint.buyKeywordAddon,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const locationMetrics = async (payload) => {
  return new Promise((resolve) => {
    API.locationMetrics(
      API.EndPoint.locationMetrics,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const gmpPostList = (
  locationId,
  isLoadMore = false,
  selectedAccountId = false,
  nextPageToken = false
) => {
  return new Promise((resolve) => {
    API.gmpPostList(
      API.EndPoint.gmpPostList +
        `/${locationId}` +
        `?accountId=${selectedAccountId}` +
        (isLoadMore ? `&pageToken=${nextPageToken}` : ''),
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const createPost = async (payload) => {
  return new Promise((resolve) => {
    API.createPost(
      API.EndPoint.createPost,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const updatePost = async (payload) => {
  return new Promise((resolve) => {
    API.updatePost(
      API.EndPoint.updatePost,
      API.Method.patch,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const deletePost = (localPostName = '', selectedAccountId = '') => {
  return new Promise((resolve) => {
    API.deletePost(
      API.EndPoint.deletePost +
        `?localPostName=${localPostName}` +
        `&accountId=${selectedAccountId}`,
      API.Method.delete,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const gmpListById = (localPostName = '', selectedAccountId = '') => {
  return new Promise((resolve) => {
    API.gmpListById(
      API.EndPoint.gmpListById +
        `?localPostName=${localPostName}` +
        `&accountId=${selectedAccountId}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const createUpdatePost = async (payload) => {
  return new Promise((resolve) => {
    API.createUpdatePost(
      API.EndPoint.createUpdatePost,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const reviewLists = (locationId, selectedAccountId) => {
  return new Promise((resolve) => {
    API.reviewLists(
      API.EndPoint.reviewLists +
        `/${locationId}` +
        `?accountId=${selectedAccountId}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const updateReview = async (payload) => {
  return new Promise((resolve) => {
    API.updateReview(
      API.EndPoint.updateReview,
      API.Method.patch,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const createKeywordFolder = async (payload) => {
  return new Promise((resolve) => {
    API.createKeywordFolder(
      API.EndPoint.createKeywordFolder,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const reNameKeywordFolder = async (payload) => {
  return new Promise((resolve) => {
    API.reNameKeywordFolder(
      API.EndPoint.reNameKeywordFolder,
      API.Method.patch,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const updateBusinessDetails = async (payload) => {
  return new Promise((resolve) => {
    API.updateBusinessDetails(
      API.EndPoint.updateBusinessDetails,
      API.Method.patch,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const keywordFolderAssign = async (payload) => {
  return new Promise((resolve) => {
    API.keywordFolderAssign(
      API.EndPoint.keywordFolderAssign,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const categoryLists = async (payload) => {
  return new Promise((resolve) => {
    API.categoryLists(
      API.EndPoint.categoryLists,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const deleteKeywordFolder = (id) => {
  return new Promise((resolve) => {
    API.deleteKeywordFolder(
      API.EndPoint.deleteKeywordFolder + `/${id}`,
      API.Method.delete,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getSubPages = async (payload) => {
  return new Promise((resolve) => {
    API.getSubPages(
      API.EndPoint.getSubPages,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const localSeoTasks = async (payload) => {
  return new Promise((resolve) => {
    API.localSeoTasks(
      API.EndPoint.localSeoTasks,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const googleAutoCompleteApi = (
  input = '',
  radius: any = null,
  isAddress = null
) => {
  return new Promise((resolve) => {
    const baseUrl = `${API.EndPoint.googleAutoCompleteApi}?input=${input}&radius=${radius}`;
    const addressParam = isAddress ? `&isAddress=${isAddress}` : '';
    const fullUrl = baseUrl + addressParam;
    API.googleAutoCompleteApi(
      fullUrl,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const createMapRanker = async (payload) => {
  return new Promise((resolve) => {
    API.createMapRanker(
      API.EndPoint.createMapRanker,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getReportDetail = async (payload) => {
  return new Promise((resolve) => {
    API.getReportDetail(
      API.EndPoint.getReportDetail,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getMapRankerHistory = () => {
  return new Promise((resolve) => {
    API.getMapRankerHistory(
      API.EndPoint.getMapRankerHistory,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const updateMapRankingMonitoring = async (payload) => {
  return new Promise((resolve) => {
    API.updateMapRankingMonitoring(
      API.EndPoint.updateMapRankingMonitoring,
      API.Method.patch,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const updateMapRanker = async (payload) => {
  return new Promise((resolve) => {
    API.updateMapRanker(
      API.EndPoint.updateMapRanker,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const disconnectGoogleBusiness = (id) => {
  return new Promise((resolve) => {
    API.disconnectGoogleBusiness(
      API.EndPoint.disconnectGoogleBusiness + `?locationId=${id}`,
      API.Method.delete,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const validateCoupon = async (payload) => {
  return new Promise((resolve) => {
    API.validateCoupon(
      API.EndPoint.validateCoupon,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getBusinessCategory = async (payload) => {
  return new Promise((resolve) => {
    API.getBusinessCategory(
      API.EndPoint.getBusinessCategory,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const createMapRankerFromInfo = async (payload) => {
  return new Promise((resolve) => {
    API.createMapRankerFromInfo(
      API.EndPoint.createMapRankerFromInfo,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const generateMapRankPdf = async (payload) => {
  return new Promise((resolve) => {
    API.generateMapRankPdf(
      API.EndPoint.generateMapRankPdf,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const cancelAddon = async (payload) => {
  return new Promise((resolve) => {
    API.cancelAddon(
      API.EndPoint.cancelAddon,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getAddonDetail = () => {
  return new Promise((resolve) => {
    API.getAddonDetail(
      API.EndPoint.getAddonDetail,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getLocalSeoPlan = () => {
  return new Promise((resolve) => {
    API.localSeoPlan(
      API.EndPoint.localSeoPlan,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getLocationDetail = async (payload) => {
  return new Promise((resolve) => {
    API.getLocationDetail(
      API.EndPoint.getLocationDetail,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const updateAiTask = async (payload) => {
  return new Promise((resolve) => {
    API.updateAiTask(
      API.EndPoint.updateAiTask,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const squareOrderToken = async (payload) => {
  return new Promise((resolve) => {
    API.squareOrderToken(
      API.EndPoint.squareOrderToken,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const createReviewWidget = async (payload) => {
  return new Promise((resolve) => {
    API.createReviewWidget(
      API.EndPoint.createReviewWidget,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const getReviewWidget = (id) => {
  return new Promise((resolve) => {
    API.getReviewWidget(
      API.EndPoint.getReviewWidget + `/${id}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getAllReviewWidgets = (id) => {
  return new Promise((resolve) => {
    API.getAllReviewWidgets(
      API.EndPoint.getAllReviewWidgets + `?locationId=${id}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const deleteReviewWidget = (id) => {
  return new Promise((resolve) => {
    API.deleteReviewWidget(
      API.EndPoint.deleteReviewWidget + `/${id}`,
      API.Method.delete,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getAllAuditedSites = () => {
  return new Promise((resolve) => {
    API.getAllAuditedSites(
      API.EndPoint.getAllAuditedSites,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const updateSquarespaceConnection = (payload) => {
  return new Promise((resolve) => {
    API.updateSquarespaceConnection(
      API.EndPoint.updateSquarespaceConnection,
      API.Method.patch,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const createAiVisibilityTasks = async (payload) => {
  return new Promise((resolve) => {
    API.createAiVisibilityTasks(
      API.EndPoint.createAiVisibilityTasks,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const visibilityDetails = (id, startDate = null, endDate = null) => {
  return new Promise((resolve) => {
    let queryParams = {
      startDate: startDate,
      endDate: endDate
    };
    const queryString = new URLSearchParams(queryParams).toString();

    API.visibilityDetails(
      API.EndPoint.visibilityDetails + `/${id}?${queryString}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const promptResult = (id, modelName = null) => {
  return new Promise((resolve) => {
    API.promptResult(
      API.EndPoint.promptResult + `/${id}?modelName=${modelName}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const visibilityGraph = (id, startDate = null, endDate = null) => {
  return new Promise((resolve) => {
    let queryParams = {
      startDate: startDate,
      endDate: endDate
    };

    const queryString = new URLSearchParams(queryParams).toString();

    API.visibilityGraph(
      API.EndPoint.visibilityGraph + `/${id}?${queryString}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const sendSiteTransferInvitation = (payload) => {
  return new Promise((resolve) => {
    API.sendSiteTransferInvitation(
      API.EndPoint.sendSiteTransferInvitation,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const siteTransferRespond = (payload) => {
  return new Promise((resolve) => {
    API.siteTransferRespond(
      API.EndPoint.siteTransferRespond,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};
// ===============================================
// For, Citation Builder
// ===============================================

/**
 * This will get the list of campaigns for the Citation Builder feature.
 *
 * @param {object} payload - The request payload to send to the server.
 * @returns {Promise<any>} A promise that resolves to the response data.
 */
const getCampaignList = (): Promise<any> => {
  return new Promise((resolve) => {
    API.getCampaignList(
      API.EndPoint.getCampaignList,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * This will create a new campaign for the Citation Builder feature.
 *
 * @param {object} payload - The request payload to send to the server.
 * @returns {Promise<any>} A promise that resolves to the response data.
 */
const scanCitations = (payload: any) => {
  return new Promise((resolve) => {
    API.scanCitations(
      API.EndPoint.scanCitations,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

/**
 * This will draft (save) a campaign for the Citation Builder feature.
 *
 * @param {object} payload - The request payload to send to the server.
 * @returns {Promise<any>} A promise that resolves to the response data.
 */
const draftACampaign = (
  payload: IDraftACampaignProps
): Promise<IDraftACampaignResponse> => {
  return new Promise<IDraftACampaignResponse>((resolve, reject) => {
    API.draftACampaign(
      API.EndPoint.draftACampaign,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        const status = response?.status;

        if (status >= 200 && status < 300) {
          resolve(response.data);
        } else {
          reject({
            status,
            data: response?.data
          });
        }
      }
    );
  });
};

/**
 * This will get a details of a campaign.
 *
 * @param payload - The request payload to send to the server. {campaign_id: number}
 * @returns {Promise<any>} A promise that resolves to the response data.
 */
const getACampaign = (payload: { campaign_id: number }) => {
  return new Promise((resolve) => {
    API.getACampaign(
      API.EndPoint.getACampaign,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response);
      }
    );
  });
};

/**
 * This will send a citation update request to BL (Bright Local).
 *
 * @param {object} payload - The request payload to send to the server.
 * @returns {Promise<any>} A promise that resolves to the response data.
 */
const citationUpdateRequest = (payload: any, campaignId: string) => {
  return new Promise((resolve) => {
    API.citationUpdateRequest(
      API.EndPoint.citationUpdateRequest + `/${campaignId}`,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const disconnectSquareSpace = (payload) => {
  return new Promise((resolve) => {
    API.disconnectSquareSpace(
      API.EndPoint.disconnectSquareSpace,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const buyAiAddon = async (payload) => {
  return new Promise((resolve) => {
    API.buyAiAddon(
      API.EndPoint.buyAiAddon,
      API.Method.post,
      undefined,
      payload,
      (response) => {
        resolve(response?.data);
      }
    );
  });
};

const disableAiVisibility = (payload) => {
  return new Promise((resolve) => {
    API.disableAiVisibility(
      API.EndPoint.disableAiVisibility,
      API.Method.put,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const createLocation = (payload) => {
  return new Promise((resolve) => {
    API.createLocation(
      API.EndPoint.createLocation,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const citationProgress = (id) => {
  return new Promise((resolve) => {
    API.citationProgress(
      API.EndPoint.citationProgress + `/${id}/progress`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const citationReport = (id) => {
  return new Promise((resolve) => {
    API.citationReport(
      API.EndPoint.citationReport + `/${id}/report`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const emailCitationReport = ({
  reportPdfURI
}): Promise<EmailReportResponse> => {
  return new Promise<EmailReportResponse>((resolve, reject) => {
    API.emailCitationReport(
      API.EndPoint.emailCitationReport,
      API.Method.post,
      undefined,
      { reportPdfURI: reportPdfURI },
      (response: any) => {
        const status = response?.status;

        if (status >= 200 && status < 300) {
          resolve(response.data);
        } else {
          reject({
            status: response?.status,
            data: response?.data
          });
        }
      }
    );
  });
};

const getLocationByLocationId = (
  locationId: string
): Promise<AxiosResponse<LocationApiResponse, any>> => {
  return new Promise<AxiosResponse<LocationApiResponse, any>>(
    (resolve, reject) => {
      API.getLocationByLocationId(
        API.EndPoint.getLocationByLocationId(locationId),
        API.Method.get,
        undefined,
        {},
        (response: any) => {
          const status = response?.status;

          if (status >= 200 && status < 300) {
            resolve(response);
          } else {
            reject({
              status: response?.status,
              data: response
            });
          }
        }
      );
    }
  );
};

const cancelSiteTransfer = (invitationId: string) => {
  return new Promise<AxiosResponse<any, any>>((resolve) => {
    API.cancelSiteTransfer(
      API.EndPoint.cancelSiteTransfer(invitationId),
      API.Method.delete,
      undefined,
      {},
      (response: AxiosResponse<any, any>) => {
        resolve(response);
      }
    );
  });
};

const getAiSummary = (payload) => {
  return new Promise((resolve) => {
    API.getAiSummary(
      API.EndPoint.getAiSummary,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const reportConfiguration = (payload) => {
  return new Promise((resolve) => {
    API.reportConfiguration(
      API.EndPoint.reportConfiguration,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getReportConfiguration = (id) => {
  return new Promise((resolve) => {
    API.getReportConfiguration(
      API.EndPoint.getReportConfiguration + `?siteId=${id}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getReportData = (id) => {
  return new Promise((resolve) => {
    API.getReportData(
      API.EndPoint.getReportData + `?siteId=${id}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getLocalSeoReportData = (id, locationId = null) => {
  return new Promise((resolve) => {
    API.getLocalSeoReportData(
      API.EndPoint.getLocalSeoReportData +
        `?siteId=${id}${locationId ? `&locationId=${locationId}` : ''}`,
      API.Method.get,
      undefined,
      {},
      (response: any) => {
        resolve(response?.data);
      }
    );
  });
};

const getKeywordsAssistance4Site = (userId: string, siteId: string) => {
  return new Promise(async (resolve, reject) => {
    API.getKeywordsAssistance4Site(
      API.EndPoint.getKeywordsAssistance4Site(userId, siteId),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response.data.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const runKeywordIntelligence = (payload: KeywordIntelligenceRunPayload) => {
  return new Promise(async (resolve, reject) => {
    API.runKeywordIntelligence(
      API.EndPoint.runKeywordIntelligence,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response.data.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const runContentStrategy = (payload: KeywordIntelligenceRunPayload) => {
  return new Promise(async (resolve, reject) => {
    API.runContentStrategy(
      API.EndPoint.runContentStrategy,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response.data.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const getContentStrategy = (userId: string, siteId: string, pagination?: any) => {
  return new Promise(async (resolve, reject) => {
    API.getContentStrategy(
      API.EndPoint.getContentStrategy(userId, siteId, pagination),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const generatePagePlan = (opportunityId: string, siteId: string, regenerate?: boolean) => {
  return new Promise(async (resolve, reject) => {
    API.generatePagePlan(
      API.EndPoint.generatePagePlan(opportunityId, siteId, regenerate),
      API.Method.post,
      undefined,
      {},
      (response: any) => {
        if((response.status === 200 || response.status === 201 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const addOpportunityToPlan = (opportunityId: string, siteId: string) => {
  return new Promise(async (resolve, reject) => {
    API.addOpportunityToPlan(
      API.EndPoint.addOpportunityToPlan(opportunityId, siteId),
      API.Method.post,
      undefined,
      {},
      (response: any) => {
        if((response.status === 200 || response.status === 201 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const ignoreOpportunity = (opportunityId: string, siteId: string) => {
  return new Promise(async (resolve, reject) => {
    API.ignoreOpportunity(
      API.EndPoint.ignoreOpportunity(opportunityId, siteId),
      API.Method.delete,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 204) && (response?.data?.status === "success" || response?.status === 200 || response?.status === 204)){
          resolve(response?.data || { status: 'success' });
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const generateBlogFromClusterBlueprint = (blueprintId: string, suggestion?: string) => {
  return new Promise(async (resolve, reject) => {
    API.generateBlogFromClusterBlueprint(
      API.EndPoint.generateBlogFromClusterBlueprint(blueprintId),
      API.Method.post,
      undefined,
      suggestion ? { suggestion } : {},
      (response: any) => {
        if((response.status === 200 || response.status === 201 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const generateClusterBlueprints = (
  clusterId: string,
  siteId?: string,
  customEndpoint?: string
) => {
  return new Promise(async (resolve, reject) => {
    let endpoint = customEndpoint
      ? customEndpoint.replace(/^(GET|POST|PATCH|DELETE|PUT)\s+/i, '').replace(/^\//, '')
      : API.EndPoint.generateClusterBlueprints(clusterId, siteId);

    if (siteId && !endpoint.includes('siteId=')) {
      endpoint += `${endpoint.includes('?') ? '&' : '?'}siteId=${siteId}`;
    }

    API.generateClusterBlueprints(
      endpoint,
      API.Method.post,
      undefined,
      {},
      (response: any) => {
        if((response.status === 200 || response.status === 201 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const getContentPlan = (siteId: string, page = 1, limit = 20) => {
  return new Promise(async (resolve, reject) => {
    API.getContentPlan(
      API.EndPoint.getContentPlan(siteId, page, limit),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && (response?.data?.status === "success" || Array.isArray(response?.data?.items))){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const getBlogBlueprints = (userId: string, siteId: string) => {
  return new Promise(async (resolve, reject) => {
    API.getBlogBlueprints(
      API.EndPoint.getBlogBlueprints(userId, siteId),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const createBlogPostBlueprints = (payload: BlogBlueprintsRunPayload) => {
  return new Promise(async (resolve, reject) => {
    API.createBlogPostBlueprints(
      API.EndPoint.createBlogPostBlueprints,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response.data.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const getGeneratedBlog = (userId: string, siteId: string) => {
  return new Promise(async (resolve, reject) => {
    API.getGeneratedBlog(
      API.EndPoint.getGeneratedBlog(userId, siteId),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const getGeneratedBlogByBlueprintId = (blueprintId: string) => {
  return new Promise(async (resolve, reject) => {
    API.getGeneratedBlogByBlueprintId(
      API.EndPoint.getGeneratedBlogByBlueprintId(blueprintId),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const generateBlog = (payload: BlogRunPayload) => {
  return new Promise(async (resolve, reject) => {
    API.generateBlog(
      API.EndPoint.generateBlog,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response.data.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const getLocalSEOAgentReport = (userId: string, siteId: string, accountId: string, locationId: string): Promise<LocalSEOAgentReport> => {
  return new Promise<LocalSEOAgentReport>(async (resolve, reject) => {
    API.getLocalSEOAgentReport(
      API.EndPoint.getLocalSEOAgentReport(userId, siteId, accountId, locationId),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const runLocalSEOAgentReport = (payload: LocalSEOAgentRunPayload) => {
  return new Promise<LocalSEOAgentReport>(async (resolve, reject) => {
    API.runLocalSEOAgentReport(
      API.EndPoint.runLocalSEOAgent,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
}

const updateReviewAutomationSettings = (payload: ReviewAutomationSettingsPayload): Promise<ReviewAutomationSettingsResponse> => {
  return new Promise(async (resolve, reject) => {
    API.updateReviewAutomationSettings(
      API.EndPoint.updateReviewAutomationSettings,
      API.Method.put,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};
const getReviewAutomationSettings = (accountId: string, locationId: string, siteId?: string): Promise<ReviewAutomationSettingsResponse> => {
  return new Promise(async (resolve, reject) => {
    API.getReviewAutomationSettings(
      API.EndPoint.getReviewAutomationSettings(accountId, locationId, siteId),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  })
};

const getReviewAutomationDashboard = (accountId: string, locationId: string, siteId: string): Promise<ReviewAutomationDashboardResponse> => {
  return new Promise(async (resolve, reject) => {
    API.getReviewAutomationDashboard(
      API.EndPoint.getReviewAutomationDashboard(accountId, locationId, siteId),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const postReviewAutomationResponse = (responseId: string, payload: { action: string; draft: string }): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    API.postReviewAutomationResponse(
      API.EndPoint.postReviewAutomationResponse(responseId),
      API.Method.put,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const getUserAgentDetails = (siteId: string): Promise<UserAgentDetailsResponse> => {
  return new Promise(async (resolve, reject) => {
    API.getUserAgentDetails(
      API.EndPoint.getUserAgentDetails(siteId),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const updateUserAgents = (payload: UpdateUserAgentsPayload): Promise<UpdateUserAgentsResponse> => {
  return new Promise(async (resolve, reject) => {
    API.updateUserAgents(
      API.EndPoint.updateUserAgents,
      API.Method.put,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const buyOrbitAIAddon = (payload: BuyAddonPayload): Promise<BuyAddonResponse> => {
  return new Promise(async (resolve, reject) => {
    API.buyOrbitAIAddon(
      API.EndPoint.buyOrbitAIAddon,
      API.Method.post,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const getAgentsStatus = (siteId: string): Promise<AgentsStatusResponse> => {
  return new Promise(async (resolve, reject) => {
    API.getAgentsStatus(
      API.EndPoint.getAgentsStatus(siteId),
      API.Method.get,
      undefined,
      null,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

const updateLocalSEOBusinessDetails = (payload: any): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    API.updateLocalSEOBusinessDetails(
      API.EndPoint.updateLocalSEOBusinessDetails,
      API.Method.patch,
      undefined,
      payload,
      (response: any) => {
        if((response.status === 200 || response.status === 202) && response?.data?.status === "success"){
          resolve(response?.data);
        } else {
          reject(response?.data);
        }
      }
    );
  });
};

export {
  updateLocalSEOBusinessDetails,
  addSubPages,
  getResponseSuggestion,
  createScan,
  getHtml,
  addSites,
  updateUser,
  getAllSuggestionDataResponse,
  updateSubPages,
  addSubPagesWithPayload,
  updateScanCount,
  userDetailsData,
  runScanChecks,
  v2UserDetails,
  v2SitesDetails,
  runCheckScan,
  getAddonDetails,
  getSubscriptionDetailsStripe,
  getDomainGoogle,
  removeSite,
  getPreviousScan,
  getInsight,
  getRecommended,
  getInsightGraph,
  deleteScan,
  getHireUs,
  paymentGetInvoices,
  getSiteAuditUrl,
  runAuditUrls,
  getAuditSiteDetail,
  auditSite,
  auditStatus,
  indiVidualScan,
  addUpdateMonitoring,
  auditCheckersCount,
  deleteSubPages,
  siteDetail,
  getKeywordsCount,
  getMonthlyTraffic,
  generateSiteDetailPdf,
  stopAudit,
  reAudit,
  getScansByIssue,
  createMember,
  slotSubscriptionUpdate,
  slotList,
  inviteUser,
  cancelInvitation,
  resendInvitation,
  deleteSlot,
  deleteMember,
  removeMultiSites,
  getSkippedUrls,
  getReAuditCount,
  getRecommendationKeys,
  generateBlogPost,
  createLeadForm,
  getLeadForm,
  createLead,
  getLeadDetails,
  getUserLeadForm,
  deleteLead,
  indexedCheckUpdate,
  getKeywordOverview,
  getRelatedKeywords,
  getCompetitorDetails,
  topOrganicKeywords,
  getCreditDetails,
  getSeoAcademy,
  getLogout,
  userRegistration,
  refreshToken,
  marketPlaceUsersCount,
  getGscGraphDetails,
  getOrganicSearchTraffic,
  createBriefPost,
  getBlogDetail,
  getCardDetail,
  buyAddon,
  getAllPlan,
  upgradeDowngradePlan,
  getPlanDetails,
  downgradeDeactivateOffers,
  resumePausedSubscription,
  topRankingKeywordSuggestions,
  keywordTracking,
  getKeywordTracking,
  deleteKeywordTracking,
  updateMonitoringFrequency,
  getCompetitorAnalysis,
  getKeywordResearchTable,
  getCompetitorAnalysisTable,
  getKeywordResearch,
  getPreviousBlogPost,
  getPreviousBlogPostIdeas,
  disconnectGSC,
  getKeywordPosition,
  getCreateUpdateKeywordList,
  getKeywordList,
  getKeywordListDetails,
  deleteKeywordList,
  deleteKeywordListDetails,
  handleDeleteScans,
  getBackLinksDetails,
  addLocalSEOTag,
  celebrationFlag,
  getAddon,
  googleBusiness,
  googleBusinessToken,
  getLocations,
  locationInfo,
  buyKeywordAddon,
  locationMetrics,
  gmpPostList,
  createPost,
  updatePost,
  deletePost,
  gmpListById,
  createUpdatePost,
  reviewLists,
  updateReview,
  createKeywordFolder,
  reNameKeywordFolder,
  keywordFolderAssign,
  deleteKeywordFolder,
  updateBusinessDetails,
  categoryLists,
  getSubPages,
  localSeoTasks,
  googleAutoCompleteApi,
  createMapRanker,
  getReportDetail,
  getMapRankerHistory,
  updateMapRankingMonitoring,
  updateMapRanker,
  disconnectGoogleBusiness,
  validateCoupon,
  getBusinessCategory,
  createMapRankerFromInfo,
  generateMapRankPdf,
  cancelAddon,
  getAddonDetail,
  getLocationDetail,
  updateAiTask,
  getLocalSeoPlan,
  squareOrderToken,
  createReviewWidget,
  getReviewWidget,
  getAllReviewWidgets,
  deleteReviewWidget,
  getAllAuditedSites,
  updateSquarespaceConnection,
  createAiVisibilityTasks,
  visibilityDetails,
  promptResult,
  visibilityGraph,
  sendSiteTransferInvitation,
  siteTransferRespond,
  getCampaignList,
  scanCitations,
  draftACampaign,
  getACampaign,
  citationUpdateRequest,
  disconnectSquareSpace,
  createLocation,
  citationProgress,
  citationReport,
  emailCitationReport,
  buyAiAddon,
  disableAiVisibility,
  getLocationByLocationId,
  cancelSiteTransfer,
  reportConfiguration,
  getAiSummary,
  getReportConfiguration,
  getReportData,
  getLocalSeoReportData,
  getKeywordsAssistance4Site,
  runKeywordIntelligence,
  runContentStrategy,
  getContentStrategy,
  generatePagePlan,
  addOpportunityToPlan,
  ignoreOpportunity,
  generateBlogFromClusterBlueprint,
  generateClusterBlueprints,
  getContentPlan,
  getBlogBlueprints,
  createBlogPostBlueprints,
  getGeneratedBlog,
  getGeneratedBlogByBlueprintId,
  generateBlog,
  getLocalSEOAgentReport,
  runLocalSEOAgentReport,
  updateReviewAutomationSettings,
  getReviewAutomationSettings,
  getReviewAutomationDashboard,
  postReviewAutomationResponse,
  getUserAgentDetails,
  updateUserAgents,
  getAgentsStatus,
  buyOrbitAIAddon
};
